import { createContext, useContext, useReducer } from "react";
import { authFetch } from "../../api";

const initialState = {
  wishlist: [],
  loading: false,
  error: null,
};

function wishlistReducer(state, action) {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, loading: true, error: null };
    case "FETCH_SUCCESS":
      return { ...state, loading: false, wishlist: action.payload };
    case "FETCH_ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const [state, dispatch] = useReducer(wishlistReducer, initialState);

  const fetchWishlist = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    try {
      dispatch({ type: "FETCH_START" });

      const res = await authFetch(
        "course-wishlist/get-user-shortlist-courses",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId }),
        }
      );

      const response = await res.json();

      if (response.success) {
        const raw = response.data.map((item) => item.gradlynk_course_id);
        const ids = raw.flatMap((id) =>
          typeof id === "string"
            ? id.split(",").map((x) => x.trim())
            : [String(id)]
        );

        dispatch({ type: "FETCH_SUCCESS", payload: ids });
      } else {
        dispatch({ type: "FETCH_ERROR", payload: response.message });
      }
    } catch (err) {
      dispatch({ type: "FETCH_ERROR", payload: err.message });
    }
  };  

  return (
    <WishlistContext.Provider value={{ ...state, fetchWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
